export const APPLIED_PROMO_TEST_ID = {
  box: 'applied-box',
  remove: 'remove-promo-button',
  title: 'title',
  description: 'description',
};
